import React, {useState, useRef} from 'react';
import {PriorityIcon, DropdownV2, Button} from '@priority-software/priority-style-react';
import styles from '../styles/SavedReports.module.scss';
import texts from '../texts';
import {ItemsList} from '../../../components/Common/ItemsList';
import {SavedReportItem, ISavedReportItemProps} from './SavedReportItem';
import {EntityType} from '../../../constants/EntityTypes';
import {SavedReport} from '../types';

interface ISavedReportsTrigger {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    type: string;
}

export const SavedReportsTrigger: React.FC<ISavedReportsTrigger> = ({isOpen, setIsOpen, type}) => {
    return (
        <Button
            skin="text"
            onClick={() => {
                setIsOpen(prevState => !prevState);
            }}
            prefixIcon={PriorityIcon.history}
            suffixIcon={isOpen ? PriorityIcon.arrowUpThin : PriorityIcon.arrowBottom}
        >
            {type === EntityType.DOCUMENT ? texts.savedDocuments : texts.savedReports}
        </Button>
    );
};

interface ISavedReportsProps extends Partial<ISavedReportItemProps> {
    initSavedReports: SavedReport[];
    type: string;
}

export const SavedReports: React.FC<ISavedReportsProps> = ({
    initSavedReports,
    closeDialog,
    dialogZIndex,
    etype,
    type,
    ename
}) => {
    const savedReportsRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [savedReports, setSavedReports] = useState(initSavedReports);

    const handleClose = () => {
        setIsOpen(false);
    };

    const onDelete = idx => {
        const temp = [...savedReports];
        temp.splice(idx, 1);
        setSavedReports(temp);
    };

    return (
        <DropdownV2
            trigger={<SavedReportsTrigger isOpen={isOpen} setIsOpen={setIsOpen} type={type} />}
            isOpen={isOpen}
            onClose={handleClose}
            contentComponentClasses={styles.dropdownContent}
        >
            <div ref={savedReportsRef} style={{height: '100%'}}>
                <ItemsList
                    items={savedReports}
                    renderItem={data => (
                        <SavedReportItem
                            containerRef={savedReportsRef}
                            dialogZIndex={dialogZIndex}
                            idx={data.index}
                            item={data.item}
                            etype={etype}
                            ename={ename}
                            onDelete={onDelete}
                            closeDialog={closeDialog}
                        />
                    )}
                />
            </div>
        </DropdownV2>
    );
};
